import { useNavigate } from "react-router-dom";
import MainContainer from "../../layout/MainContainer";
import RolesList from "../../features/manageSubAdmin/rolesList";

const ManageSubadminRoles = () => {

  const navigate = useNavigate();

  return (
    <MainContainer>
      <div className="main_title">
        <h1>Manage Roles</h1>
        <p>
          <span onClick={() => navigate("/dashboard")}>Dashboard</span>
          {' '} - <span onClick={() => navigate("/manage-subadmin")}>Manage Sub-Admin</span>
          {' '} - Manage Roles
        </p>
      </div>

      <div className="cards">

        <RolesList />
      </div>
    </MainContainer>
  );
};

export default ManageSubadminRoles;
